import React from 'react';
import classNames from 'classnames';
import _get from 'lodash/get';
import { useTranslation } from 'react-i18next';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import { SelectPanelOptionRendererProps } from '../types';
import { getOptionLabel } from '../utils';
import styles from '../SelectPanel.module.scss';

export function CheckedOption({
  option,
  isSelected,
}: SelectPanelOptionRendererProps): React.ReactElement {
  const { t } = useTranslation();
  const isCreateOption = _get(option, '__isNew__');
  const icon = _get(option, 'data.icon');

  return (
    <div
      className={classNames(styles.option, styles.checkedOption, {
        active: isSelected,
        [styles.checkedOptionWithLeftIcon]: !!icon,
      })}
    >
      {icon && (
        <span className={styles.optionCheckbox}>
          <MaterialIcon icon={icon} size="md-24" symbolsOutlined />
        </span>
      )}
      {getOptionLabel(option, t)}
      {isSelected && (
        <span className={styles.optionCheckbox}>
          <MaterialIcon icon="check" size="md-18" />
        </span>
      )}
      {isCreateOption && (
        <span className={styles.optionCheckbox}>
          <MaterialIcon icon="keyboard_return" size="md-18" />
        </span>
      )}
    </div>
  );
}
